import { theme } from '@hhgtech/hhg-components'

type Props = {
  color?: string
  size?: number
}

const DoubleArrowIcon = ({ size = 18, color = theme.colors.white }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.69641 8.99999L8.73972 12.0547C8.84347 12.1586 8.89847 12.2872 8.90472 12.4406C8.91097 12.594 8.85597 12.7289 8.73972 12.8452C8.63097 12.9539 8.49922 13.0082 8.34447 13.0082C8.18972 13.0082 8.05797 12.9539 7.94922 12.8452L4.57872 9.47455C4.50847 9.4043 4.45891 9.33024 4.43003 9.25236C4.40116 9.17449 4.38672 9.09036 4.38672 8.99999C4.38672 8.90961 4.40116 8.82549 4.43003 8.74761C4.45891 8.66974 4.50847 8.59567 4.57872 8.52542L7.94922 5.15474C8.05309 5.05099 8.18172 4.99599 8.33509 4.98974C8.48847 4.98349 8.62334 5.03849 8.73972 5.15474C8.84834 5.26349 8.90266 5.39524 8.90266 5.54999C8.90266 5.70474 8.84834 5.83649 8.73972 5.94524L5.69641 8.99999ZM10.4589 8.99999L13.5022 12.0547C13.606 12.1586 13.661 12.2872 13.6672 12.4406C13.6735 12.594 13.6185 12.7289 13.5022 12.8452C13.3935 12.9539 13.2617 13.0082 13.107 13.0082C12.9522 13.0082 12.8205 12.9539 12.7117 12.8452L9.34103 9.47455C9.27091 9.4043 9.22141 9.33024 9.19253 9.25236C9.16366 9.17449 9.14922 9.09036 9.14922 8.99999C9.14922 8.90961 9.16366 8.82549 9.19253 8.74761C9.22141 8.66974 9.27091 8.59567 9.34103 8.52542L12.7117 5.15474C12.8156 5.05099 12.9442 4.99599 13.0976 4.98974C13.251 4.98349 13.3858 5.03849 13.5022 5.15474C13.6108 5.26349 13.6652 5.39524 13.6652 5.54999C13.6652 5.70474 13.6108 5.83649 13.5022 5.94524L10.4589 8.99999Z"
        fill={color}
      />
    </svg>
  )
}

export default DoubleArrowIcon
